import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { CurrentMedicationModel } from '../models/CurrentMedicationModel';
import { URLsConfig } from '../URLsConfig';
import { DateSelectionModelChange } from '@angular/material/datepicker';

@Injectable()
export class CurrentMedicationService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

  public getCurrentMedicationAll(patientCode: string ,cmsource: string, compcode: string) {

      let params = new HttpParams();
        params = params.append("PatientCode", patientCode);
        params = params.append("CMSource", cmsource);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<CurrentMedicationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/CurrentMedication/GetCurrentMedication',options);
    }

    public getHomeMedication(patientCode: string,cmdate: string ,cmsource: string, compcode: string) {

      let params = new HttpParams();
        params = params.append("PatientCode", patientCode);
        params = params.append("CMDate", cmdate);
        params = params.append("CMSource", cmsource);
        params = params.append("CompCode", compcode);
        const options = {
          params: params
      };
      return this.http.get<CurrentMedicationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/CurrentMedication/GetHomeMedication',options);
    }

    public AddCurrentMedication(SHistory: CurrentMedicationModel) {
      return this.http.post<CurrentMedicationModel>(this.urlsconfig.WebAPIURL_Test + 'api/CurrentMedication/AddCurrentMedication', SHistory);
    }

    public delCurrentMedication(patientCode: string ,drugref: string, compcode: string) {

    let params = new HttpParams();
    params = params.append("PatientCode", patientCode);
    params = params.append("DrugRef", drugref);
    params = params.append("CompCode", compcode);


      const options = {
        params: params
    };
    return this.http.get<CurrentMedicationModel>(this.urlsconfig.WebAPIURL_Test + 'api/CurrentMedication/DeleteCurrentMedication',options);
    }

  }
